import loadable from '@loadable/component';

export const ProductTabReviews = loadable(
  () =>
    import(
      /* webpackChunkName: "product-tab-reviews" */ './product-tab-reviews'
    )
);
